(() => {
  const PROMO_ACTIVE = true;
  const THRESHOLD_CENTS = 20000;
  const GIFT_VARIANT_ID = 48262178472106;
  const GIFT_MARKER_KEY = '_auto_gwp';
  const TOAST_ADD_MSG = 'Free gift added to your cart 🎁';
  const TOAST_REMOVE_MSG = 'Free gift removed because your cart is below $200';

  let isUpdating = false;

  function showToast(message) {
    let toast = document.getElementById('gwp-toast');
    if (!toast) {
      const style = document.createElement('style');
      style.textContent = `
        #gwp-toast {
          position: fixed; left: 50%; bottom: 24px;
          transform: translateX(-50%);
          background: #000; color: #fff;
          padding: 12px 18px; border-radius: 30px;
          z-index: 999999; font-size: 14px;
          opacity: 0; transition: opacity .2s ease;
          pointer-events: none;
        }
        #gwp-toast.show { opacity: 1; }
      `;
      document.head.appendChild(style);
      toast = document.createElement('div');
      toast.id = 'gwp-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('show');
    clearTimeout(window.gwpToastTimer);
    window.gwpToastTimer = setTimeout(() => toast.classList.remove('show'), 3000);
  }

  async function getCart() {
    const response = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
    return response.json();
  }

  function getGiftItem(cart) {
    return cart.items.find(item => Number(item.variant_id) === Number(GIFT_VARIANT_ID));
  }

  function getSubtotalWithoutGift(cart) {
    return cart.items.reduce((total, item) => {
      if (Number(item.variant_id) === Number(GIFT_VARIANT_ID)) return total;
      return total + item.original_line_price;
    }, 0);
  }

  async function addGift() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: GIFT_VARIANT_ID,
        quantity: 1,
        properties: { [GIFT_MARKER_KEY]: 'true' }
      })
    });
  }

  async function removeGift(giftItem) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: giftItem.key, quantity: 0 })
    });
  }

  function findCartDrawerInstance() {
    // 1. Scan all window properties (including non-enumerable)
    for (const key of Object.getOwnPropertyNames(window)) {
      try {
        const val = window[key];
        if (!val || typeof val !== 'object') continue;
        if (typeof val.updateCartDrawer === 'function') return val;
        // One level deep
        for (const subkey of Object.getOwnPropertyNames(val)) {
          try {
            const sub = val[subkey];
            if (sub && typeof sub.updateCartDrawer === 'function') return sub;
          } catch (e) {}
        }
      } catch (e) {}
    }

    // 2. Scan every DOM element's own properties
    for (const el of document.querySelectorAll('*')) {
      for (const key of Object.getOwnPropertyNames(el)) {
        try {
          const val = el[key];
          if (val && typeof val.updateCartDrawer === 'function') return val;
        } catch (e) {}
      }
      // Also jQuery data
      if (window.jQuery) {
        const data = window.jQuery(el).data() || {};
        for (const val of Object.values(data)) {
          if (val && typeof val.updateCartDrawer === 'function') return val;
        }
      }
    }

    return null;
  }

  async function refreshDrawer() {
    await new Promise(r => setTimeout(r, 300));

    try {
      const cart = await getCart();
      const instance = findCartDrawerInstance();

      if (instance) {
        console.log('GWP: Found CartDrawer instance ✓');
        await instance.updateCartDrawer(cart);
      } else {
        // ── Deep debug: find exactly where updateCartDrawer lives ──
        console.warn('GWP: CartDrawer instance still not found. Running deep scan...');

        // Log all window keys that are objects
        const interesting = [];
        for (const key of Object.getOwnPropertyNames(window)) {
          try {
            const val = window[key];
            if (val && typeof val === 'object' && !['window','self','top','parent','frames'].includes(key)) {
              interesting.push({ key, type: val.constructor?.name, keys: Object.getOwnPropertyNames(val).slice(0, 10) });
            }
          } catch (e) {}
        }
        console.log('GWP debug — all window objects:', interesting);

        // Log DOM elements that have non-standard own properties
        for (const el of document.querySelectorAll('*')) {
          const ownKeys = Object.getOwnPropertyNames(el).filter(k =>
            !['0','length','nodeType'].includes(k) && isNaN(k)
          );
          if (ownKeys.length > 0) {
            console.log('GWP debug — element with own props:', el.tagName, el.id || el.className, ownKeys);
          }
        }
      }
    } catch (e) {
      console.warn('GWP refreshDrawer error:', e);
    }
  }

  async function syncGift() {
    if (isUpdating) return;
    if (!PROMO_ACTIVE) return;
    isUpdating = true;

    try {
      const cart = await getCart();
      const subtotalWithoutGift = getSubtotalWithoutGift(cart);
      const giftItem = getGiftItem(cart);

      if (subtotalWithoutGift >= THRESHOLD_CENTS && !giftItem) {
        const response = await addGift();
        if (response.ok) {
          showToast(TOAST_ADD_MSG);
          await refreshDrawer();
        } else {
          console.error('GWP add error:', await response.json().catch(() => null));
        }
      }

      if (subtotalWithoutGift < THRESHOLD_CENTS && giftItem) {
        const response = await removeGift(giftItem);
        if (response.ok) {
          showToast(TOAST_REMOVE_MSG);
          await refreshDrawer();
        } else {
          console.error('GWP remove error:', await response.json().catch(() => null));
        }
      }
    } catch (e) {
      console.error('GWP error:', e);
    } finally {
      isUpdating = false;
    }
  }

  function delayedSyncs() {
    setTimeout(syncGift, 500);
    setTimeout(syncGift, 1200);
    setTimeout(syncGift, 2200);
  }

  document.addEventListener('DOMContentLoaded', () => delayedSyncs());
  document.addEventListener('click', e => { if (e.target.closest('button, a, input')) delayedSyncs(); }, true);
  document.addEventListener('change', () => delayedSyncs(), true);
  document.addEventListener('submit', () => delayedSyncs(), true);
  document.addEventListener('cart:refresh', delayedSyncs);
  document.addEventListener('cart:updated', delayedSyncs);
  document.addEventListener('ajaxCart:updated', delayedSyncs);
  document.addEventListener('cart:change', delayedSyncs);

  const originalFetch = window.fetch;
  window.fetch = async function () {
    const response = await originalFetch.apply(this, arguments);
    try {
      const url = typeof arguments[0] === 'string' ? arguments[0] : arguments[0]?.url;
      if (url && /\/cart\/(add|change|update|clear)/.test(url)) delayedSyncs();
    } catch (e) {}
    return response;
  };

  setInterval(syncGift, 5000);
})();